import { checkInPathFor } from "./eventLinks";

const ACTIVE_CHECK_IN_KEY = "ln_active_check_in_v1";

export function activeCheckInPath(active) {
  if (!active?.event_id) return null;
  const path = checkInPathFor(active, active.occurrence_date);
  if (!path) clearActiveCheckIn(active.event_id, active.occurrence_date);
  return path;
}

export function getActiveCheckIn() {
  try {
    return JSON.parse(localStorage.getItem(ACTIVE_CHECK_IN_KEY) || "null");
  } catch {
    return null;
  }
}

/** Active check-in scoped to the current dancer session (ignores other personas/devices). */
export function getActiveCheckInForSession(dancerId = null) {
  const active = getActiveCheckIn();
  if (!active?.event_id || !active.checked_in_at) return null;
  if (active.dancer_id) {
    return dancerId && active.dancer_id === dancerId ? active : null;
  }
  return dancerId ? active : null;
}

export function setActiveCheckIn(active) {
  if (!active?.event_id || !active.checked_in_at) return;
  localStorage.setItem(ACTIVE_CHECK_IN_KEY, JSON.stringify({
    event_id: active.event_id,
    occurrence_date: active.occurrence_date || null,
    checked_in_at: active.checked_in_at,
    dancer_id: active.dancer_id || null,
    public_path: active.public_path || null,
  }));
}

export function clearActiveCheckIn(eventId = null, occurrenceDate = null) {
  const current = getActiveCheckIn();
  if (!current) return;
  if (eventId && current.event_id !== eventId) return;
  if (occurrenceDate && current.occurrence_date !== occurrenceDate) return;
  localStorage.removeItem(ACTIVE_CHECK_IN_KEY);
  clearLiveBannerSettled(eventId || current.event_id, occurrenceDate || current.occurrence_date);
}

export function liveBannerSettledKey(eventId, occurrenceDate = null) {
  return `ln_feed_live_settled_${eventId}_${occurrenceDate || "none"}`;
}

export function isLiveBannerSettled(eventId, occurrenceDate = null) {
  try {
    return sessionStorage.getItem(liveBannerSettledKey(eventId, occurrenceDate)) === "1";
  } catch {
    return false;
  }
}

export function markLiveBannerSettled(eventId, occurrenceDate = null) {
  try {
    sessionStorage.setItem(liveBannerSettledKey(eventId, occurrenceDate), "1");
  } catch {
    /* ignore */
  }
}

export function clearLiveBannerSettled(eventId, occurrenceDate = null) {
  try {
    sessionStorage.removeItem(liveBannerSettledKey(eventId, occurrenceDate));
  } catch {
    /* ignore */
  }
}

export function matchesActiveCheckIn(active, eventId, occurrenceDate = null) {
  if (!active?.event_id || active.event_id !== eventId) return false;
  if (active.occurrence_date && occurrenceDate && active.occurrence_date !== occurrenceDate) {
    return false;
  }
  return true;
}

export function hasActiveCheckInElsewhere(active, eventId, occurrenceDate = null) {
  if (!active?.event_id) return false;
  return !matchesActiveCheckIn(active, eventId, occurrenceDate);
}

export function findCheckedInFeedEntry(feed) {
  const entries = [...(feed?.check_in || []), ...(feed?.your_nights || [])];
  for (const item of entries) {
    const checkedInAt = item.checked_in_at || item.my_rsvp?.checked_in_at;
    if (!checkedInAt) continue;
    return {
      event_id: item.event_id,
      occurrence_date: item.occurrence_date || item.my_rsvp?.occurrence_date || null,
      checked_in_at: checkedInAt,
    };
  }
  return null;
}

/** Align localStorage with server feed when the user is checked in tonight. */
export function syncActiveCheckInFromFeed(feed, { dancerId = null, authoritative = true } = {}) {
  const fromFeed = findCheckedInFeedEntry(feed);
  if (fromFeed) {
    setActiveCheckIn({ ...fromFeed, dancer_id: dancerId || feed?.dancer_id || null });
    return fromFeed;
  }
  if (authoritative) {
    clearActiveCheckIn();
    return null;
  }
  return getActiveCheckInForSession(dancerId);
}
